const mutations = {
    setSupplierList(state,data){
        state.supplierList=data;
    },
    setSupplier(state,data){
        state.supplier=data;
    },
    resetSupplier(state){
        state.supplier = {
            name: '',
            address: '',
            phone: '',
            gstNumber: '',
            
        }
    }
    
}
export default mutations;